<template>
  <div style="display: inline">
    <slot></slot>
    <v-row justify="center">
      <v-dialog
        v-model="value"
        :max-width="maxWidth"
        persistent
      >
        <v-card class="pa-3">

          <v-card-text class="text-center">
            <span class="dialog-title">{{ title === '' ? $t('general.confirm_delete_title') : title }}</span> <br>
            <div :class="`text-xs-${msgAlign}`">
              <div v-html="(msg === '' ? $t('general.confirm_delete_msg') : msg)"></div>
            </div>
          </v-card-text>

          <v-card-actions>
            <v-col class="text-center">
              <v-btn
                @click="$emit('input', false)"
              >
                {{ cancel_btn === '' ? $t('general.confirm_delete_cancel') : cancel_btn }}
              </v-btn>

              <v-btn
                color="accent"
                @click="$emit('confirm')"
              >
                {{ confirm_btn === '' ? $t('general.confirm_delete_confirm') : confirm_btn }}
              </v-btn>
            </v-col>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </div>
</template>

<script>
export default {
  name: 'wrld-confirm-btn',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    maxWidth: {
      type: String,
      default: 'max-content'
    },
    title: {
      type: String,
      default: ''
    },
    msg: {
      type: String,
      default: ''
    },
    msgAlign: {
      type: String,
      default: 'center'
    },
    cancel_btn: {
      type: String,
      default: ''
    },
    confirm_btn: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss" scoped>
  .dialog-title {
    font-size: 24px;
    font-weight: 400;
    padding-bottom: 15px
  }
</style>
